import React, { useState, useEffect, useRef, useCallback } from "react";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";

const SelectAllSelectSearchMultiple = ({ item, inputData, setInputData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Debug initial props
  console.log("Initial inputData:", inputData);
  console.log("setInputData is function:", typeof setInputData === "function");

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter options based on search term
  const filteredItems = item.options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  // Handle individual selection
  const handleCheckboxChange = useCallback(
    (option) => {
      console.log("Checkbox clicked, option:", option);
      console.log("Current inputData before update:", inputData, item.key);
      setInputData((prev) => {
        const currentValues = prev[item.key] || [];
        const isSelected = currentValues.some(
          (item) => item.value === option.value,
        );
        const newValues = isSelected
          ? currentValues.filter((item) => item.value !== option.value)
          : [...currentValues, option];
        console.log("New values:", newValues);
        const newState = { ...prev, [item.key]: newValues };
        console.log("New inputData after update:", newState);
        return newState;
      });
    },
    [inputData, item.key, setInputData],
  );

  // Handle select all
  const handleSelectAll = useCallback(() => {
    console.log("Select All clicked");
    console.log("Current inputData before update:", inputData);
    setInputData((prev) => {
      const currentValues = prev[item.key] || [];
      const newValues =
        currentValues.length === item.options.length ? [] : [...item.options];
      console.log("New values (Select All):", newValues);
      const newState = { ...prev, [item.key]: newValues };
      console.log("New inputData after update:", newState);
      return newState;
    });
  }, [inputData, item.key, setInputData, item.options]);

  // Check if all items are selected
  const isAllSelected =
    (inputData[item.key] || []).length === item.options.length;
  console.log("isAllSelected:", isAllSelected);
  console.log(inputData, "sdjfueue");

  return (
    <div className={`w-full col-span-${item.col} font-sans`} ref={dropdownRef}>
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center h-[38px] justify-between w-full px-4 py-2 text-right bg-white border border-edit_input_border rounded-[4px] shadow-sm focus:outline-none hover:border-blue-400 transition-all duration-200"
        >
          <span className="text-gray-700 text-[14px]">
            {(inputData[item.key] || []).length > 0
              ? `${(inputData[item.key] || []).length} مورد انتخاب شده`
              : "انتخاب کنید"}
          </span>
          <svg
            className={`w-4 h-4 mr-2 inline-block transform transition-transform duration-200 ${
              isOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {isOpen && (
          <div className="absolute z-20 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-80 overflow-y-auto">
            <div className="p-3">
              <input
                type="text"
                placeholder="جستجو..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-3 py-2 text-right bg-gray-50 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-400 transition-all duration-200 placeholder:text-[14px]"
              />
            </div>
            <div className="border-t border-gray-100 hover:bg-blue-50">
              <div
                className="flex items-center gap-2 px-4 py-2 cursor-pointer w-fit"
                onClick={handleSelectAll}
              >
                <CustomCheckbox
                  checked={isAllSelected}
                  onClick={handleSelectAll}
                />
                <span className="text-sm text-gray-700">انتخاب همه</span>
              </div>
            </div>
            {filteredItems.map((option) => (
              <div key={option.value} className={"hover:bg-blue-50"}>
                <div
                  className="flex items-center gap-2 px-4 py-2 cursor-pointer"
                  onClick={() => handleCheckboxChange(option)}
                >
                  <CustomCheckbox
                    checked={(inputData[item.key] || []).some(
                      (sel) => sel.value === option.value,
                    )}
                    onClick={() => handleCheckboxChange(option)}
                  />
                  <span className="text-sm text-gray-700">{option.label}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectAllSelectSearchMultiple;
